module.exports = __webpack_public_path__ + "img/worldcup-logo.17d8c85e.webp";